module.exports = __webpack_public_path__ + "static/socialsharetwitter-aa7f3d3cfc2d12448b6a41d4a06f5c9b.jpg";